import { atom } from "jotai"
import AccountModal from "./AccountModal"

export const accountModalAtom = atom(false)

export default AccountModal
